import "./Home.scss";
import Chatbot from "./Chatbot.js";

function Home() {
  return (
    <div className="Home">
      <Chatbot></Chatbot>
      <header className="Home-header">
        <img src="profile-pic.png" className="Home-logo" alt="logo" />

        <p>Hello and welcome to my professional portfolio website!</p>
        <br></br>

        <div id="credentials">
          <a href="https://www.linkedin.com/in/felix-g%C3%BCndling-4b143a1b5/">
            <img src="LinkedIn_logo_initials.png.webp" alt="logo" />
          </a>

          <a href="https://github.com/fguendling">
            <img src="github-mark.png" alt="logo" />
          </a>

          <a href="https://www.credly.com/users/felix-gundling.5266ff70">
            <img src="credly.png" alt="logo" />
          </a>
        </div>
      </header>

      <div
        data-aos="zoom-in"
        data-aos-offset="200"
        class="main-content-container"
      >
        <h1>What I'm currently interested in.</h1>
        <img
          id="word_cloud"
          src="word_cloud.svg"
          alt="Word Cloud"
          width="90%"
        ></img>
      </div>

      <div
        data-aos="zoom-in"
        data-aos-offset="400"
        class="main-content-container"
      >
        <h1>What I have done in the past.</h1>

        {/*
      Original Cards Design:
      https://codepen.io/aron-tw/pen/pLJqgE
      */}
        <a href={`/details/9`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#1a1a2e" }}>
              <h2 id="project9" className="text-shadow">
                Project 9
              </h2>
            </div>
            <div className="back" style={{ background: "#1a1a2e" }}>
              <h2>Kubernetes Platform Engineering</h2>
              <p>For a client in the defense industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/8`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#ff6b6b" }}>
              <h2 id="project8" className="text-shadow">
                Project 8
              </h2>
            </div>
            <div className="back" style={{ background: "#ff6b6b" }}>
              <h2>Ansible automation via self-hosted Docker Swarm</h2>
              <p>For a client in the telecommunications industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/7`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#e6e6fa" }}>
              <h2 id="project7" className="text-shadow">
                Project 7
              </h2>
            </div>
            <div className="back" style={{ background: "#e6e6fa" }}>
              <h2>Kubernetes Platform Engineering</h2>
              <p>For a software vendor</p>
            </div>
          </div>
        </a>

        <a href={`/details/6`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#81d8d0" }}>
              <h2 id="project6" className="text-shadow">
                Project 6
              </h2>
            </div>
            <div className="back" style={{ background: "#81d8d0" }}>
              <h2>Systems Development and Operation</h2>
              <p>For a client in the pharmaceutical industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/5`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#e4decd" }}>
              <h2 id="project5" className="text-shadow">
                Project 5
              </h2>
            </div>
            <div className="back" style={{ background: "#e4decd" }}>
              <h2>Cloud Foundation Design (GCP)</h2>
              <p>For a client in the energy industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/4`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#ffdab9" }}>
              <h2 id="project4" className="text-shadow">
                Project 4
              </h2>
            </div>
            <div className="back" style={{ background: "#ffdab9" }}>
              <h2>Solution Design & Software Development</h2>
              <p>For a client in the aerospace industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/3`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#7c677f" }}>
              <h2 id="project3" className="text-shadow">
                Project 3
              </h2>
            </div>
            <div className="back" style={{ background: "#7c677f" }}>
              <h2>AI methods evaluation and prototyping</h2>
              <p>For a client in the logistics industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/2`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#333333" }}>
              <h2 id="project2" className="text-shadow">
                Project 2
              </h2>
            </div>
            <div className="back" style={{ background: "#333333" }}>
              <h2>Consulting, database development</h2>
              <p>For a client in the banking industry</p>
            </div>
          </div>
        </a>

        <a href={`/details/1`}>
          <div className="flip flip-vertical">
            <div className="front" style={{ background: "#4b6777" }}>
              <h2 id="project1" className="text-shadow">
                Project 1
              </h2>
            </div>
            <div className="back" style={{ background: "#4b6777" }}>
              <h2>Database development</h2>
              <p>For a client in the banking industry (yet another one)</p>
            </div>
          </div>
        </a>
      </div>

      <br></br>
      <footer>© 2026 Felix Gündling</footer>
    </div>
  );
}

export default Home;
